// extracted by mini-css-extract-plugin
module.exports = {"markdown":"markdown-styles_markdown__HwUWZ"};